import { MaintenanceAspectServiceBase } from './maintenance-aspect.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@scisys-uim/uim-common';


@Injectable({
  providedIn: 'root'
})
export class MaintenanceAspectService extends MaintenanceAspectServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

}



